// extracted by mini-css-extract-plugin
export default {"main":"RouterComponent_main__GECTj"};